export default "__VITE_ASSET__BpjmMQj7__"